import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import { required } from '../../../utils/validation';
import RenderInputOrder from '../../input/renderInputOrder';
import {
  StringToInt,
  StringToDouble,
  _convertTradeTp,
  numberFormat,
} from '../../../utils';

import ReactModal from 'react-modal';
import { Card } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { setToast } from '../../../containers/client/actions';
import {
  makeGetStockDetail,
  makeGetToken,
  makeGetDefaultAccount,
  makeGetAuth,
  makeGetSymbolInfo,
} from '../../../lib/selector';
import { v4 as uuidv4 } from 'uuid';
import { translate } from 'react-i18next';
const customStyles = {
  content: {
    top: '80px',
    left: '50%',
    width: '500px',
    transform: 'translate(-50%)',
    bottom: 'auto',
  },
  overlay: {
    backgroundColor: 'transparent',
    zIndex: '3',
  },
};

class FormEditOrder extends Component {
  _handleToast = (msg) => {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: this.props.t('txt-notice'),
    };
    this.props.dispatch(setToast(toastMsg));
  };

  submit = (values) => {
    const {
      order,
      stockDetail,
      symbolInfo,
      defaultAccount,
      token,
      auth,
      t,
    } = this.props;
    const orderTradeTp = _convertTradeTp(values.newPrice);

    console.log(order, token, auth);

    // valid
    if (orderTradeTp === '00') {
      this._handleToast(t('txt-price-not-match'));
      return;
    }

    let _validPrice = true,
      _validVol = true;

    const _c = symbolInfo
      ? symbolInfo.highLmtPx
      : Math.round(stockDetail.c * 1000);
    const _f = symbolInfo
      ? symbolInfo.lowLmtPx
      : Math.round(stockDetail.f * 1000);

    if (orderTradeTp === '01') {
      // nhap gia double
      const vPrice = StringToDouble(values.newPrice);
      if (vPrice * 1000 > _c) {
        this._handleToast(
          t('txt-price-not-over') + ' ' + numberFormat(_c / 1000, 2)
        );
        return;
      }
      if (vPrice * 1000 < _f) {
        this._handleToast(
          t('txt-price-not-less') + ' ' + numberFormat(_f / 1000, 2)
        );
        return;
      }

      if (stockDetail.mc === '10') {
        _validPrice = this._validPriceHose(vPrice);
      } else {
        _validPrice = this._validPriceHnx(vPrice);
      }
    } else {
      this._handleToast(t('txt-price-not-match'));
      return;
    }

    const vVolume = StringToInt(values.newVol);
    if (stockDetail.mc === '10') {
      _validVol = this._validVolHose(vVolume);
    } else {
      _validVol = this._validVolHnx(vVolume);
    }

    if (_validPrice && _validVol) {
      const uuid = uuidv4();
      const params = {
        group: 'CORE',
        user: token.user,
        session: token.session,
        cmd: 'EditOrder',
        type: auth.type,
        token: auth.token,
        rqId: uuid,
        channel: 'WTS',
        data: {
          origOrdrNo: order.ordrNo + '',
          acntNo: defaultAccount.acntNo,
          subAcntNo: order.subAcntNo,
          ordrQty: vVolume,
          ordrUntprc: (StringToDouble(values.newPrice) * 1000).toFixed(0),
          ordrTrdTp: '01',
        },
      };

      this.props.handleSubmitOrder(params);
      this.props.reset();
    }
  };

  _validVolHose = (vol) => {
    let step = 10;
    if (vol < 1 || vol > 500000) {
      this._handleToast(this.props.t('txt-vol-not-match'));
      return false;
    }
    if (vol % step !== 0) {
      this._handleToast(this.props.t('txt-vol-not-match'));
      return false;
    }

    return true;
  };

  _validVolHnx = (vol) => {
    let step = 100;
    if (vol === 0) {
      this._handleToast(this.props.t('txt-vol-not-match'));
      return false;
    }
    if (vol >= 100 && vol % step !== 0) {
      this._handleToast(this.props.t('txt-vol-not-match'));
      return false;
    }

    return true;
  };

  _validPriceHose = (price) => {
    let step = 10;
    if (price < 10) step = 10;
    else if (price >= 10 && price < 50) step = 50;
    else step = 100;

    if (Math.round((price * 1000 * 10) % (step * 10)) % 10 !== 0) {
      this._handleToast(this.props.t('txt-price-not-match'));
      return false;
    }
    return true;
  };

  _validPriceHnx = (price) => {
    let step = 100;
    // console.log(price * 1000, (price * 1000) % step)
    if (Math.round((price * 1000 * 10) % (step * 10)) % 10 !== 0) {
      this._handleToast(this.props.t('txt-price-not-match'));
      return false;
    }
    return true;
  };

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      showModal,
      handleCloseModal,
      order,
      t,
    } = this.props;

    return (
      <ReactModal
        isOpen={showModal}
        contentLabel="onRequestClose Example"
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
      >
        <Card>
          <Card.Header>
            <span>{t('txt-title-edit-confirm')}</span>
            <FaTimes
              onClick={handleCloseModal}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            />
          </Card.Header>
          <Card.Body>
            <form className="form-trade" onSubmit={handleSubmit(this.submit)}>
              <table className="table table-no-bordered">
                <tbody>
                  <tr>
                    <td className="fz-14 content-read">{t('txt-symbol')}</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && order.symbol}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">{t('txt-orderNo')}</td>
                    <td className="fz-14 content-read font-weight-bold">
                      {order && order.ordrNo}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">{t('txt-type')}</td>
                    <td
                      className={
                        'fz-18 content-read text-uppercase font-weight-bold ' +
                        (order && (order.buySelTp === '1' ? 'i' : 'd'))
                      }
                    >
                      {order &&
                        (order.buySelTp === '1' ? t('txt-buy') : t('txt-sell'))}
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">{t('txt-price')}</td>
                    <td>
                      <Field
                        name="newPrice"
                        type="text"
                        className="form-control input-order content-read fz-14 text-right"
                        placeholder={t('txt-price')}
                        component={RenderInputOrder}
                        autoFocus={true}
                        validate={[required]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 content-read">
                      {t('txt-origin-vol')}
                    </td>
                    <td>
                      <Field
                        name="newVol"
                        type="text"
                        className="form-control input-order content-read text-uppercase fz-14 text-right"
                        placeholder={t('txt-vol')}
                        component={RenderInputOrder}
                        validate={[required]}
                      />
                    </td>
                  </tr>
                  {/**
                  <tr>
                    <td className="fz-14 content-read">PIN</td>
                    <td>
                      <Field
                        name="pin"
                        type="password"
                        className="form-control input-order content-read text-uppercase fz-14"
                        placeholder="Nhập mã PIN"
                        component={RenderInputOrder}
                        validate={[required]}
                      />
                    </td>
                  </tr>
                  */}
                </tbody>
              </table>
              <div className="d-flex justify-content-center mt-2">
                <button
                  type="submit"
                  disabled={pristine || submitting}
                  className="btn font-weight-bold fz-14 ml-2 btn-order order-buy"
                >
                  {t('txt-accept')}
                </button>
                <button
                  type="button"
                  disabled={submitting}
                  onClick={handleCloseModal}
                  className="btn font-weight-bold fz-14 btn-order ml-2"
                >
                  {t('txt-cancel')}
                </button>
              </div>
            </form>
          </Card.Body>
        </Card>
      </ReactModal>
    );
  }
}

FormEditOrder = reduxForm({
  form: 'editOrder',
  enableReinitialize: true,
})(FormEditOrder);

const selector = formValueSelector('editOrder');

const makeMapStateToProps = () => {
  const getStockDetail = makeGetStockDetail();
  const getSymbolInfo = makeGetSymbolInfo();
  const getToken = makeGetToken();
  const getDefaultAccount = makeGetDefaultAccount();
  const getAuth = makeGetAuth();

  const mapStateToProps = (state, props) => {
    const { newPrice, newVol } = selector(state, 'newPrice', 'newVol');
    return {
      newPrice,
      newVol,
      initialValues: {
        newPrice: (props.order ? props.order.ordrUntprc / 1000 : 0) + '',
        newVol: (props.order ? props.order.ordrQty : 0) + '',
      },
      token: getToken(state),
      stockDetail: getStockDetail(state),
      symbolInfo: getSymbolInfo(state),
      defaultAccount: getDefaultAccount(state),
      auth: getAuth(state),
    };
  };
  return mapStateToProps;
};

FormEditOrder = connect(makeMapStateToProps)(FormEditOrder);

export default translate('translations')(FormEditOrder);
